import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'ui/Text';

const Intro = () => {
  return (
    <div className="intro-banner why-cdr">
      <Text modifiers="question-title primary-blue">
        <FormattedMessage
          id="Questionnaire.CDR.SubMenuItem.0"
          defaultMessage="Why Capacity Diagnostic Report?"
        />
      </Text>
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.WhyCDR.Explanation.1"
          defaultMessage={`
            Thank you for your application! Please find below your capacity diagnostic report. 
            This report gives you an overview of how you performed during the application process. 
            This is an excellent opportunity to reflect on your organization’s level of 
            development in each of the eight key areas of organizational capacity.
          `}
        />
      </Text>
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.WhyCDR.Explanation.2"
          defaultMessage={`
            Please feel free to use this as a resource for further discussions with your teams  and with 
            donors to inspire support for capacity development in these main areas. 
            We congratulate you on your willingness to assess your organization and lead it towards 
            even greater impact in your community. 
          `}
        />
      </Text>   
      <Text type="explanation">
        <FormattedMessage
          id="Questionnaire.CDR.WhyCDR.Explanation.3"
          defaultMessage={`
            EPIC Africa's goal is to strengthen African Civil Society Organizations. In addition 
            to providing free tools for self assessment, we will work with individual CSOs to 
            address their specific capacity development needs. To learn more about our capacity 
            building services, please visit our website or contact consultingservices@epic-africa.org
          `}
        />
      </Text>         
    </div>
  );
};

export default Intro;


// WEBPACK FOOTER //
// ./src/components/CDRSections/Intro.js